import { render, staticRenderFns } from "./CaseStudyPage.vue?vue&type=template&id=b9b89c40"
import script from "./CaseStudyPage.vue?vue&type=script&lang=js"
export * from "./CaseStudyPage.vue?vue&type=script&lang=js"
import style0 from "./CaseStudyPage.vue?vue&type=style&index=0&id=b9b89c40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports